import { Injectable, effect, inject } from '@angular/core';
import { Router } from '@angular/router';

import { isCurrentLocationPublic, isPublicAppRoute } from '../utils/public-route.util';
import { AuthService } from './auth.service';

/**
 * Redirects to login when the session ends while the user is on a protected screen
 * (token expiry, 401 refresh failure, force logout, etc.). Route guards only run on
 * navigation, so this covers in-place session loss.
 *
 * Patient assessment links (`/nc/assessment/...`) are anonymous and must never bounce
 * to login — including during app bootstrap, when `router.url` is still `/`.
 */
@Injectable({ providedIn: 'root' })
export class AuthRedirectService {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  constructor() {
    effect(() => {
      if (this.auth.isAuthenticated()) return;

      // Prefer the browser path — reliable during bootstrap and after logout.
      if (isCurrentLocationPublic()) return;

      const routerUrl = this.router.url ?? '';
      if (isPublicAppRoute(routerUrl)) return;

      void this.router.navigateByUrl('/auth/login');
    });
  }
}
